(() => {
  const trigger = document.querySelector('.tgc-gallery-zoom');
  const dialog = document.getElementById('tgcImageDialog');
  const track = document.getElementById('pdpGalleryTrack');
  if (!trigger || !dialog || !track) return;
  const expanded = dialog.querySelector('.tgc-image-expanded');
  trigger.addEventListener('click', () => {
    const index = Math.round(track.scrollLeft / track.clientWidth);
    const image = track.children[index]?.querySelector('img');
    if (!image) return;
    const source = new URL(image.currentSrc || image.src);
    source.searchParams.set('width', '2000');
    expanded.src = source.href;
    expanded.alt = image.alt;
    dialog.showModal();
  });
  dialog.querySelector('.tgc-image-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
})();
